<template>
  <div class="spin-wrap" v-if="loading">
    <a-spin class="spin-item" :spinning="loading" />
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean
  },
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
</style>
